import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoimagicacab() {



const cardData = {
  keyword: "Pune to Imagica Cab ",

"headingDescription": "SRS Cab Service provides Pune to Imagica Cab, offering a comfortable, safe, and reliable travel solution for families, groups, and adventure seekers heading to the popular Imagica Theme Park. Our professional drivers, well-maintained vehicles, and timely pickups ensure a smooth and hassle-free journey from Pune to Imagica. With flexible booking options, transparent pricing, and 24/7 customer support, SRS Cab Service makes your trip to Imagica convenient, fun, and memorable.",
"topPlaces": [
  {
    "title": "Imagica Theme Park",
    "description": "Imagica is a world-class amusement and theme park offering thrilling rides, entertainment zones, and adventure activities. Travelers using SRS Cab Service from Pune often spend the day enjoying roller coasters, water rides, and family-friendly attractions."
  },
  {
    "title": "Imagica Water Park",
    "description": "The water park at Imagica features slides, wave pools, and fun water activities. Visitors traveling with SRS Cab Service often enjoy a refreshing day here with family and friends."
  },
  {
    "title": "Imagica Snow Park",
    "description": "Imagica Snow Park offers snow-based activities and experiences. Travelers using SRS Cab Service often include this unique attraction for a fun-filled day."
  },
  {
    "title": "Adventure Rides at Imagica",
    "description": "Imagica’s adventure rides, including high-thrill roller coasters and simulators, are a must-visit. Visitors using SRS Cab Service from Pune enjoy these rides as part of their exciting itinerary."
  },
  {
    "title": "Live Entertainment Shows",
    "description": "Imagica hosts live shows, performances, and street entertainment. Travelers using SRS Cab Service often plan their visit around these shows for a complete experience."
  },
  {
    "title": "Food & Dining at Imagica",
    "description": "Imagica offers a variety of restaurants and food courts. Visitors traveling with SRS Cab Service can enjoy a range of cuisines while taking a break from rides and attractions."
  },
  {
    "title": "Souvenir Shops",
    "description": "Imagica’s souvenir shops provide themed merchandise and mementos. Travelers using SRS Cab Service often shop here for keepsakes from their trip."
  },
  {
    "title": "Imagica Resorts",
    "description": "Imagica Resorts offer comfortable stays near the park. Visitors using SRS Cab Service can combine their cab ride with overnight stays for a complete trip experience."
  },
  {
    "title": "Family Attractions",
    "description": "Imagica features family-friendly zones and attractions suitable for kids of all ages. Travelers using SRS Cab Service enjoy these areas for a fun day out."
  },
  {
    "title": "Adventure Zones",
    "description": "Imagica has multiple adventure zones for thrill-seekers. Visitors using SRS Cab Service from Pune often include these zones in their itinerary for maximum excitement."
  }
],



services: [
{
name: "Cab from Pune to Imagica",
description: "Cab from Pune to Imagica offers comfortable travel for theme park visits. Customers can book cabs for family and group outings. Professional drivers ensure safe highway journeys. Comfortable vehicles enhance travel experience. Flexible booking options are available. Travel easily from Pune to Imagica with cab services."
},
{
name: "Pune to Adlabs Imagica Cab",
description: "Pune to Adlabs Imagica cab provides reliable transportation for fun trips. Customers can book vehicles for one-day outings. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily to Imagica with cab services."
},
{
name: "Pune to Adlabs Imagica Cab Charges",
description: "Pune to Adlabs Imagica cab charges provide clear pricing details for travel planning. Customers can check charges before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent charges."
},
{
name: "Pune to Imagica Cab Fare",
description: "Pune to Imagica cab fare offers detailed pricing for trips. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab fare services."
},
{
name: "Pune to Imagica Cab Price",
description: "Pune to Imagica cab price provides clear pricing information for travelers. Customers can check price estimates before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent pricing."
},
{
name: "Pune to Imagica Cab Service",
description: "Pune to Imagica cab service offers dependable transportation for leisure trips. Customers can book cabs for one-day outings. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Imagica Taxi",
description: "Pune to Imagica taxi provides convenient travel for theme park visits. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with taxi services."
},
{
name: "Pune to Imagica Taxi Fare",
description: "Pune to Imagica taxi fare provides estimated pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with taxi fare services."
},
{
name: "Pune to Imagica Cab Charges",
description: "Pune to Imagica cab charges offer clear pricing for customers. Travelers can check charges before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent charges."
},
{
name: "Pune to Imagica Taxi Booking",
description: "Pune to Imagica taxi booking provides quick and easy reservation options. Customers can book taxis online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily from Pune."
},
{
name: "Pune to Imagica Car Rental",
description: "Pune to Imagica car rental offers flexible vehicle options for travel. Customers can rent cars for family and group trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Rent cars easily from Pune to Imagica."
},
{
name: "Pune to Imagica Chauffeur-Driven Cabs",
description: "Pune to Imagica chauffeur-driven cabs provide premium travel experience. Customers can enjoy professional driver services. Comfortable vehicles enhance travel experience. Safe and smooth journeys are ensured. Flexible booking options are available. Travel easily with chauffeur-driven cab services."
},
{
name: "Pune to Imagica Taxi Rates",
description: "Pune to Imagica taxi rates provide clear pricing details for travelers. Customers can check rates before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent rates."
},
{
name: "Pune to Imagica Cab Pricing",
description: "Pune to Imagica cab pricing offers detailed cost breakdown for trips. Customers can compare pricing options before booking. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose cab services with transparent pricing."
},
{
name: "Pune to Imagica Private Car Hire",
description: "Pune to Imagica private car hire offers personalized travel for families and groups. Customers can hire vehicles for flexible trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with private car hire services."
},
{
name: "Pune to Imagica Cab Cost",
description: "Pune to Imagica cab cost provides pricing details for travelers. Customers can estimate trip cost before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab cost services."
},
{
name: "Pune to Imagica Taxi Service Charges",
description: "Pune to Imagica taxi service charges offer clear pricing for travel services. Customers can check charges before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent charges."
},
{
name: "Pune to Imagica Travel Fare",
description: "Pune to Imagica travel fare provides estimated pricing for trips. Customers can compare fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with fare services."
},
{
name: "Pune to Imagica Cab",
description: "Pune to Imagica cab offers reliable transportation for leisure travel. Customers can book cabs for one-day outings. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services from Pune."
},
{
name: "Pune to Imagica Taxi Service",
description: "Pune to Imagica taxi service provides convenient travel for theme park visits. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Taxi Fare from Pune to Imagica",
description: "Taxi fare from Pune to Imagica provides detailed pricing for travel planning. Customers can check fare estimates before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with taxi fare services."
},
{
name: "Innova Cab Pune to Imagica",
description: "Innova cab Pune to Imagica offers premium SUV travel for comfortable trips. Customers can enjoy spacious seating and luggage space. Professional drivers ensure safe journeys. Ideal for family travel. Transparent pricing ensures value for money. Travel comfortably with Innova cab services."
},
{
name: "Innova Crysta Cab Pune to Imagica",
description: "Innova Crysta cab Pune to Imagica provides luxury travel experience. Customers can enjoy premium comfort and smooth rides. Professional drivers ensure safe journeys. Ideal for group trips. Transparent pricing ensures value for money. Travel easily with Innova Crysta services."
},
{
name: "Ertiga Cab Pune to Imagica",
description: "Ertiga cab Pune to Imagica offers comfortable 7-seater travel for families. Customers can enjoy smooth journeys for outings. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
}
],

tableData: [
["Cab from Pune to Imagica","Pune to Adlabs Imagica Cab"],
["Pune to Adlabs Imagica Cab Charges","Pune to Imagica Cab Fare"],
["Pune to Imagica Cab Price","Pune to Imagica Cab Service"],
["Pune to Imagica Taxi","Pune to Imagica Taxi Fare"],
["Pune to Imagica Cab Charges","Pune to Imagica Taxi Booking"],
["Pune to Imagica Car Rental","Pune to Imagica Chauffeur-Driven Cabs"],
["Pune to Imagica Taxi Rates","Pune to Imagica Cab Pricing"],
["Pune to Imagica Private Car Hire","Pune to Imagica Cab Cost"],
["Pune to Imagica Taxi Service Charges","Pune to Imagica Travel Fare"],
["Pune to Imagica Cab","Pune to Imagica Taxi Service"],
["Taxi Fare from Pune to Imagica","Innova Cab Pune to Imagica"],
["Innova Crysta Cab Pune to Imagica","Ertiga Cab Pune to Imagica"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Imagica Route Drivers",
    WhyChoosedescription: "SRS Cab Service provides skilled drivers familiar with Pune to Imagica routes via expressway, ensuring smooth navigation and a safe journey."
  },
  {
    WhyChooseheading: "Affordable Pune to Imagica Cab Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune to Imagica cab services with transparent pricing. Customers receive clear fare details with no hidden charges."
  },
  {
    WhyChooseheading: "Perfect for Family & Group Trips",
    WhyChoosedescription: "Our cab service is ideal for families, friends, and corporate outings visiting Imagica Theme Park, offering comfortable and hassle-free travel."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Imagica cab bookings, making it convenient for early morning departures and late evening returns."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "We provide clean, well-maintained, and air-conditioned vehicles to ensure a comfortable and relaxing journey to Imagica."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We offer one-way cab service, round-trip bookings, and same-day return packages for Pune to Imagica travel."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for all group sizes."
  },
  {
    WhyChooseheading: "Trusted Travel Service to Imagica",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Imagica cab bookings due to reliable service, punctual drivers, and comfortable travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Imagica cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Imagica Theme Park." },
  { question: "How far is Imagica from Pune?", answer: "The distance between Pune and Imagica is approximately 90 km and the journey takes around 2 to 2.5 hours." },
  { question: "Is Pune to Imagica cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for Imagica trip?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pune to Imagica?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Do you provide same-day return from Imagica?", answer: "Yes, we offer same-day return packages for Pune to Imagica trips." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Imagica cab service online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Patil",
    feedback:
      "Booked SRS Cab Service for Imagica trip. Smooth journey and perfect for family outing.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Riya Sharma",
    feedback:
      "Best Pune to Imagica cab service. Comfortable ride and on-time pickup.",
    rating: 5
  }
];































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Imagica Cab | SRS Cab",
  "description": "SRS Cab provides Pune to Imagica cab services including one-way and round trips, taxi booking, car rentals, and chauffeur-driven cabs. Book safe, comfortable, and affordable rides from Pune to Adlabs Imagica with 24x7 online booking and best cab fares.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};







  return (
    <div>
      
<Helmet>
  <title>Pune to Imagica Cab | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Imagica cabs with SRS Cab. One-way, round trips, taxi booking, car rentals, and chauffeur-driven cabs from Pune to Adlabs Imagica. Affordable fares with safe and comfortable 24x7 online booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/36.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoimagicacab;